(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : (global = global || self, global.multeiThemes = factory());
})(this, function () {
  'use strict';
  /**
   * Do not edit directly
   * Generated on Sun, 31 May 2020 00:29:40 GMT
   */

  var index_esm = {
    "color": {
      "background": {
        "code": {
          "value": "#000000",
          "original": {
            "value": "{color.base.gray.transparent.value}"
          },
          "name": "ColorBackgroundCode",
          "attributes": {
            "category": "color",
            "type": "background",
            "item": "code"
          },
          "path": ["color", "background", "code"]
        },
        "default": {
          "value": "#623cea",
          "original": {
            "value": "{color.base.purple.medium.value}"
          },
          "name": "ColorBackgroundDefault",
          "attributes": {
            "category": "color",
            "type": "background",
            "item": "default"
          },
          "path": ["color", "background", "default"]
        },
        "error": {
          "value": "#a63446",
          "original": {
            "value": "{color.base.red.value}"
          },
          "name": "ColorBackgroundError",
          "attributes": {
            "category": "color",
            "type": "background",
            "item": "error"
          },
          "path": ["color", "background", "error"]
        },
        "info": {
          "value": "#5887ff",
          "original": {
            "value": "{color.base.blue.value}"
          },
          "name": "ColorBackgroundInfo",
          "attributes": {
            "category": "color",
            "type": "background",
            "item": "info"
          },
          "path": ["color", "background", "info"]
        },
        "mark": {
          "value": "#f4ff52",
          "original": {
            "value": "{color.base.yellow.value}"
          },
          "name": "ColorBackgroundMark",
          "attributes": {
            "category": "color",
            "type": "background",
            "item": "mark"
          },
          "path": ["color", "background", "mark"]
        },
        "paper": {
          "light": {
            "value": "#f6f4f3",
            "original": {
              "value": "{color.base.white.value}"
            },
            "name": "ColorBackgroundPaperLight",
            "attributes": {
              "category": "color",
              "type": "background",
              "item": "paper",
              "subitem": "light"
            },
            "path": ["color", "background", "paper", "light"]
          },
          "dark": {
            "value": "#140c2f",
            "original": {
              "value": "{color.base.purple.dark.value}"
            },
            "name": "ColorBackgroundPaperDark",
            "attributes": {
              "category": "color",
              "type": "background",
              "item": "paper",
              "subitem": "dark"
            },
            "path": ["color", "background", "paper", "dark"]
          }
        },
        "success": {
          "value": "#71b340",
          "original": {
            "value": "{color.base.green.value}"
          },
          "name": "ColorBackgroundSuccess",
          "attributes": {
            "category": "color",
            "type": "background",
            "item": "success"
          },
          "path": ["color", "background", "success"]
        },
        "warning": {
          "value": "#f49f0a",
          "original": {
            "value": "{color.base.orange.value}"
          },
          "name": "ColorBackgroundWarning",
          "attributes": {
            "category": "color",
            "type": "background",
            "item": "warning"
          },
          "path": ["color", "background", "warning"]
        }
      },
      "base": {
        "black": {
          "opaque": {
            "value": "#0f1108",
            "original": {
              "value": "#0f1108"
            },
            "name": "ColorBaseBlackOpaque",
            "attributes": {
              "category": "color",
              "type": "base",
              "item": "black",
              "subitem": "opaque"
            },
            "path": ["color", "base", "black", "opaque"]
          },
          "transparent": {
            "value": "#000000",
            "original": {
              "value": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0.8
              }
            },
            "name": "ColorBaseBlackTransparent",
            "attributes": {
              "category": "color",
              "type": "base",
              "item": "black",
              "subitem": "transparent"
            },
            "path": ["color", "base", "black", "transparent"]
          }
        },
        "blue": {
          "value": "#5887ff",
          "original": {
            "value": "#5887FF"
          },
          "name": "ColorBaseBlue",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "blue"
          },
          "path": ["color", "base", "blue"]
        },
        "blueGreen": {
          "deprecated": true,
          "deprecated_comment": "replace with the \"blue\" color",
          "value": "#119da4",
          "original": {
            "deprecated": true,
            "deprecated_comment": "replace with the \"blue\" color",
            "value": "#119DA4"
          },
          "name": "ColorBaseBlueGreen",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "blueGreen"
          },
          "path": ["color", "base", "blueGreen"]
        },
        "gray": {
          "transparent": {
            "value": "#000000",
            "original": {
              "value": {
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 0.2
              }
            },
            "name": "ColorBaseGrayTransparent",
            "attributes": {
              "category": "color",
              "type": "base",
              "item": "gray",
              "subitem": "transparent"
            },
            "path": ["color", "base", "gray", "transparent"]
          }
        },
        "green": {
          "value": "#71b340",
          "original": {
            "value": "#71B340"
          },
          "name": "ColorBaseGreen",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "green"
          },
          "path": ["color", "base", "green"]
        },
        "orange": {
          "value": "#f49f0a",
          "original": {
            "value": "#F49F0A"
          },
          "name": "ColorBaseOrange",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "orange"
          },
          "path": ["color", "base", "orange"]
        },
        "purple": {
          "medium": {
            "value": "#623cea",
            "original": {
              "value": "#623CEA"
            },
            "name": "ColorBasePurpleMedium",
            "attributes": {
              "category": "color",
              "type": "base",
              "item": "purple",
              "subitem": "medium"
            },
            "path": ["color", "base", "purple", "medium"]
          },
          "dark": {
            "value": "#140c2f",
            "original": {
              "value": "#140C2F"
            },
            "name": "ColorBasePurpleDark",
            "attributes": {
              "category": "color",
              "type": "base",
              "item": "purple",
              "subitem": "dark"
            },
            "path": ["color", "base", "purple", "dark"]
          }
        },
        "red": {
          "value": "#a63446",
          "original": {
            "value": "#A63446"
          },
          "name": "ColorBaseRed",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "red"
          },
          "path": ["color", "base", "red"]
        },
        "white": {
          "value": "#f6f4f3",
          "original": {
            "value": "#f6f4f3"
          },
          "name": "ColorBaseWhite",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "white"
          },
          "path": ["color", "base", "white"]
        },
        "yellow": {
          "value": "#f4ff52",
          "original": {
            "value": "#F4FF52"
          },
          "name": "ColorBaseYellow",
          "attributes": {
            "category": "color",
            "type": "base",
            "item": "yellow"
          },
          "path": ["color", "base", "yellow"]
        }
      },
      "brand": {
        "primary": {
          "value": "#623cea",
          "original": {
            "value": "{color.base.purple.medium.value}"
          },
          "name": "ColorBrandPrimary",
          "attributes": {
            "category": "color",
            "type": "brand",
            "item": "primary"
          },
          "path": ["color", "brand", "primary"]
        },
        "secondary": {
          "value": "#5887ff",
          "original": {
            "value": "{color.base.blue.value}"
          },
          "name": "ColorBrandSecondary",
          "attributes": {
            "category": "color",
            "type": "brand",
            "item": "secondary"
          },
          "path": ["color", "brand", "secondary"]
        }
      },
      "font": {
        "error": {
          "value": "#f6f4f3",
          "original": {
            "value": "{color.base.white.value}"
          },
          "name": "ColorFontError",
          "attributes": {
            "category": "color",
            "type": "font",
            "item": "error"
          },
          "path": ["color", "font", "error"]
        },
        "info": {
          "value": "#f6f4f3",
          "original": {
            "value": "{color.base.white.value}"
          },
          "name": "ColorFontInfo",
          "attributes": {
            "category": "color",
            "type": "font",
            "item": "info"
          },
          "path": ["color", "font", "info"]
        },
        "mark": {
          "value": "#0f1108",
          "original": {
            "value": "{color.base.black.opaque.value}"
          },
          "name": "ColorFontMark",
          "attributes": {
            "category": "color",
            "type": "font",
            "item": "mark"
          },
          "path": ["color", "font", "mark"]
        },
        "primary": {
          "value": "#f6f4f3",
          "original": {
            "value": "{color.base.white.value}"
          },
          "name": "ColorFontPrimary",
          "attributes": {
            "category": "color",
            "type": "font",
            "item": "primary"
          },
          "path": ["color", "font", "primary"]
        },
        "secondary": {
          "value": "#f6f4f3",
          "original": {
            "value": "{color.base.white.value}"
          },
          "name": "ColorFontSecondary",
          "attributes": {
            "category": "color",
            "type": "font",
            "item": "secondary"
          },
          "path": ["color", "font", "secondary"]
        },
        "success": {
          "value": "#000000",
          "original": {
            "value": "{color.base.black.transparent.value}"
          },
          "name": "ColorFontSuccess",
          "attributes": {
            "category": "color",
            "type": "font",
            "item": "success"
          },
          "path": ["color", "font", "success"]
        },
        "warning": {
          "value": "#000000",
          "original": {
            "value": "{color.base.black.transparent.value}"
          },
          "name": "ColorFontWarning",
          "attributes": {
            "category": "color",
            "type": "font",
            "item": "warning"
          },
          "path": ["color", "font", "warning"]
        }
      }
    },
    "font": {
      "family": {
        "base": {
          "value": "Overpass, \"-apple-system\", BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif",
          "original": {
            "value": "Overpass, \"-apple-system\", BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif"
          },
          "name": "FontFamilyBase",
          "attributes": {
            "category": "font",
            "type": "family",
            "item": "base"
          },
          "path": ["font", "family", "base"]
        }
      }
    }
  };

  var base = function base(_ref) {
    var _ref$palette = _ref.palette,
        paper = _ref$palette.background.paper,
        type = _ref$palette.type;
    return {
      overrides: {
        MuiCssBaseline: {
          "@global": {
            code: {
              backgroundColor: index_esm.color.background.code.value
            },
            mark: {
              backgroundColor: index_esm.color.background.mark.value,
              color: index_esm.color.font.mark.value
            }
          }
        }
      },
      palette: {
        background: {
          "default": index_esm.color.background["default"].value,
          paper: paper
        },
        common: {
          black: index_esm.color.base.black.opaque.value,
          white: index_esm.color.base.white.value
        },
        error: {
          main: index_esm.color.background.error.value,
          contrastText: index_esm.color.font.error.value
        },
        info: {
          main: index_esm.color.background.info.value,
          contrastText: index_esm.color.font.info.value
        },
        primary: {
          main: index_esm.color.brand.primary.value,
          contrastText: index_esm.color.font.primary.value
        },
        secondary: {
          main: index_esm.color.brand.secondary.value,
          contrastText: index_esm.color.font.secondary.value
        },
        success: {
          main: index_esm.color.background.success.value,
          contrastText: index_esm.color.font.success.value
        },
        type: type,
        warning: {
          main: index_esm.color.background.warning.value,
          contrastText: index_esm.color.font.warning.value
        }
      },
      typography: {
        fontFamily: index_esm.font.family.base.value
      }
    };
  };

  var dark = base({
    palette: {
      background: {
        paper: index_esm.color.background.paper.dark.value
      },
      type: "dark"
    }
  });
  var light = base({
    palette: {
      background: {
        paper: index_esm.color.background.paper.light.value
      },
      type: "light"
    }
  });
  var index = {
    dark: dark,
    light: light
  };
  return index;
});